import React from 'react';
import styles from '../../styles/components/common/Loader.module.css';

/**
 * Unified Loader Component
 * Supports multiple loader types used across the application
 * 
 * @param {Object} props
 * @param {string} props.type - Type of loader: 'page', 'section', 'spinner', 'bar', 'error'
 * @param {string} props.message - Loading message to display
 * @param {string} props.size - Size: 'small', 'medium', 'large'
 * @param {boolean} props.fullPage - Whether to take full page height
 * @param {string} props.className - Additional CSS classes
 * @param {Object} props.style - Inline styles
 * @param {string} props.errorMessage - Error message for error type
 */
const Loader = ({ 
    type = 'page', 
    message = 'Loading...', 
    size = 'medium',
    fullPage = false,
    className = '',
    style = {},
    errorMessage = ''
}) => {
    const getLoaderContent = () => {
        switch (type) {
            case 'spinner':
                return (
                    <div className={styles.spinnerContainer}>
                        <div className={`${styles.spinner} ${styles[size]}`}></div>
                        <p className={styles.message}>{message}</p>
                    </div>
                );
            
            case 'bar':
                return (
                    <div className={styles.barContainer}>
                        <h1 className={styles.title}>{message}</h1>
                        <div className={`${styles.loadingBar} ${styles[size]}`}></div>
                    </div>
                );
            
            case 'section':
                return (
                    <div className={styles.sectionContainer}>
                        <div className={`${styles.sectionSpinner} ${styles[size]}`}></div>
                    </div>
                );
            
            case 'error':
                return (
                    <div className={styles.errorContainer}>
                        <h1 className={styles.errorTitle}>{message}</h1>
                        {errorMessage && <p className={styles.errorMessage}>{errorMessage}</p>}
                    </div>
                );
            
            case 'page':
            default:
                return (
                    <div className={styles.pageContainer}>
                        <h1 className={styles.pageTitle}>{message}</h1>
                        <div className={styles.pageBar}></div>
                    </div>
                );
        }
    };

    const containerClass = [
        styles.loaderWrapper,
        fullPage ? styles.fullPage : '',
        styles[type],
        className
    ].filter(Boolean).join(' ');

    return (
        <div className={containerClass} style={style}>
            {getLoaderContent()}
        </div>
    );
};

export default Loader;
